import createBuyerIntentView from './createBuyerIntentView'

const BuyerIntentCompetitorsView = createBuyerIntentView({
  displayName: 'BuyerIntentCompetitorsView',
  tag: 'products.competitors',
})

export default BuyerIntentCompetitorsView
